import styled from "styled-components"
import { Color, getColor } from "../../../theme/color"
import { getUnitAsPixels } from "../../../theme/layout"
import { Type, getTypography } from "../../../theme/typography"

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getUnitAsPixels({ multiplier: 1 })};

  h2{
    ${getTypography(Type.HEADING_4)}
    color: ${getColor(Color.DARK_BLUE)};
    text-align: center;
  }

  p{
    ${getTypography(Type.FORM_BODY)}
    color: ${getColor(Color.LIGHT_PURPLE)};
    text-align: center;
  }
`

export const StyledButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getUnitAsPixels({ multiplier: 1 })};
`

export const Countdown = styled.p`
  ${getTypography(Type.FIELD_LABEL)}
  color: ${getColor(Color.LIGHT_PURPLE)};
  text-align: center;
  margin-top: ${getUnitAsPixels({ multiplier: 1 })};
`